"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledReadIconContainer = exports.StyledMessageFlexContainer = exports.StyledOuterActionButtonContainer = exports.StyledActionButtonContainer = exports.StyledMessageContainer = exports.StyledMessageBubble = exports.StyledMessageDate = exports.StyledInformationMessageBody = exports.StyledHr = exports.StyledMessageBody = exports.StyledSenderName = exports.StyledDisplayName = exports.StyledAvatarWrapper = exports.StyledAvatarAndName = exports.StyledListItem = exports.StyledListHeader = exports.StyledList = exports.StyledDateDivider = exports.StyledUnreadBadgeContainer = exports.StyledThreadBodyContainer = exports.StyledActionButton = exports.StyledFooter = exports.StyledHeader = exports.StyledThread = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const focusHover_1 = require("../../../styles/focusHover");
const Tokens = __importStar(require("../../../styles/tokens"));
const Button_1 = require("../../Button/Button");
const StackPanel_1 = require("../../Layout/StackPanel/StackPanel");
const Text_1 = require("../../Text/Text");
const { SIZES, COLOURS, BORDERS } = Tokens;
const { silver, white } = COLOURS.greyscale;
/* **** Thread styles **** */
exports.StyledThread = styled_components_1.default.section `
    border-radius: ${SIZES[1]};
    display: flex;
    flex-direction: column;
    height: 100%;
`;
/* **** Header & Footer styles **** */
exports.StyledHeader = styled_components_1.default.header `
    padding: ${SIZES[2]};
    border-bottom: solid ${silver} 1px;
    border-top-left-radius: ${SIZES[1]};
    border-top-right-radius: ${SIZES[1]};
`;
exports.StyledFooter = styled_components_1.default.footer `
    padding: ${SIZES[1]};
    border-top: solid ${silver} 1px;
    border-bottom-left-radius: ${SIZES[1]};
    border-bottom-right-radius: ${SIZES[1]};
`;
// N.B. Can't do a normal styled(Button) here as it messes with the Jest tests ¯\_(ツ)_/¯
// see https://github.com/styled-components/styled-components/issues/1449
exports.StyledActionButton = (0, styled_components_1.default)((props) => (react_1.default.createElement(Button_1.Button, Object.assign({}, props)))) `
    justify-content: center;
    width: 100%;
`;
/* **** Body styles **** */
// N.B. Need the overflow !important for IE compatibility for some reason
exports.StyledThreadBodyContainer = styled_components_1.default.div `
    overflow-x: hidden;
    overflow-y: scroll !important;
    flex-grow: 1;

    margin: 0;
    padding: ${SIZES[2.5]} ${SIZES[3]} ${SIZES[1.5]};

    @media (max-width: ${Tokens.BREAKPOINTS.sm}) {
        padding: ${SIZES[1.5]} ${SIZES[2]};
    }
`;
/* **** UnreadBadge styles **** */
exports.StyledUnreadBadgeContainer = styled_components_1.default.div `
    display: flex;
    padding: ${SIZES[2]};
    justify-content: center;
`;
/* **** DateDivider styles **** */
/**
 * @deprecated use <Thread.List> instead
 */
exports.StyledDateDivider = styled_components_1.default.li `
    margin-bottom: ${SIZES[2]};
    display: flex;
    justify-content: center;
    list-style: none;

    align-items: center;
    ::before {
        margin-right: ${SIZES[2]};
        content: "";
        flex: 1;
        border-bottom: solid ${silver} 1px;
    }
    ::after {
        margin-left: ${SIZES[2]};
        content: "";
        flex: 1;
        border-bottom: solid ${silver} 1px;
    }
`;
/* **** Message group styles **** */
exports.StyledList = styled_components_1.default.ul `
    ${focusHover_1.defaultStyles}
    margin: 0;
    padding: 0;
    list-style-type: none;

    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusOnlyStyles}
    }
`;
exports.StyledListHeader = styled_components_1.default.span `
    margin-bottom: ${SIZES[2]};
    display: flex;
    justify-content: center;

    align-items: center;
    ::before {
        margin-right: ${SIZES[2]};
        content: "";
        flex: 1;
        border-bottom: solid ${silver} 1px;
    }
    ::after {
        margin-left: ${SIZES[2]};
        content: "";
        flex: 1;
        border-bottom: solid ${silver} 1px;
    }
`;
/** Item in a message style */
exports.StyledListItem = styled_components_1.default.li `
    ${focusHover_1.defaultStyles}

    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusOnlyStyles}
    }
`;
exports.StyledAvatarAndName = styled_components_1.default.div `
    display: flex;
    align-items: center;
`;
exports.StyledAvatarWrapper = styled_components_1.default.div `
    margin-right: ${SIZES[1]};
`;
exports.StyledDisplayName = styled_components_1.default.div `
    align-items: center;
    display: flex;
`;
exports.StyledSenderName = styled_components_1.default.span `
    margin-right: ${SIZES[1]};
`;
exports.StyledMessageBody = styled_components_1.default.div `
    white-space: pre-line;
    padding: ${SIZES[2]};
`;
exports.StyledHr = styled_components_1.default.hr `
    border-left: 0;
    border-right: 0;
    border-top: 1px solid ${silver};
`;
exports.StyledInformationMessageBody = styled_components_1.default.div `
    width: 100%;
    text-align: center;
    margin-bottom: ${SIZES[2]};
    display: flex;
    justify-content: center;
`;
exports.StyledMessageDate = (0, styled_components_1.default)(Text_1.Text) `
    text-align: right;
`;
exports.StyledMessageBubble = styled_components_1.default.div `
    border-radius: ${SIZES[1]};
    width: 100%;
    list-style: none;
    overflow-wrap: break-word;
`;
exports.StyledMessageContainer = styled_components_1.default.div `
    width: 65%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: ${SIZES[1]};
    padding: 0;

    @media (max-width: ${Tokens.BREAKPOINTS.sm}) {
        width: 90%;
    }
`;
exports.StyledActionButtonContainer = styled_components_1.default.div `
    display: flex;
    gap: ${SIZES[1]};
    flex-wrap: wrap;
`;
exports.StyledOuterActionButtonContainer = (0, styled_components_1.default)(exports.StyledActionButtonContainer) `
    margin: 0 ${SIZES[1]};
`;
exports.StyledMessageFlexContainer = styled_components_1.default.div `
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: ${SIZES[2]};
    ${({ inboxType }) => {
    const styles = {};
    switch (inboxType) {
        case "received":
            styles.flexDirection = "row-reverse";
            break;
        case "sent":
        default:
            styles.flexDirection = "row";
            break;
    }
    return styles;
}}

    ${exports.StyledMessageBubble} {
        ${({ inboxType, hasFailed }) => {
    const styles = {};
    switch (inboxType) {
        case "received":
        case "sent":
        default:
            styles.backgroundColor = white;
            styles.border = hasFailed
                ? BORDERS.soft.red
                : BORDERS.normal.silver;
            styles.borderRadius = BORDERS.radius;
            break;
    }
    return styles;
}}
    }
`;
const pulse = (0, styled_components_1.keyframes) `
  50% {
    transform: scale3d(1.5, 1.5, 1.5);
  }
`;
const pulseAnimation = () => (0, styled_components_1.css) `
    animation: ${pulse} 0.35s ease-in-out;
    animation-iteration-count: 1;
`;
exports.StyledReadIconContainer = (0, styled_components_1.default)(StackPanel_1.StackPanel) `
    ${({ animate }) => {
    return animate && pulseAnimation;
}}
`;
//# sourceMappingURL=Thread.styles.js.map